// Legacy events may store language-only codes (e.g., "en") instead of full locale codes (e.g., "en-US")
const LEGACY_LANGUAGE_CODE_MAP: Readonly<Record<string, string>> = {
  en: 'en-US',
  de: 'de-DE',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  ja: 'ja-JP',
};

/**
 * Normalizes language-only codes to full locale codes for backward compatibility.
 * E.g., 'en' → 'en-US', 'de' → 'de-DE'. Full locale codes pass through unchanged.
 */
export function normalizeLanguageCode(code: string): string {
  return LEGACY_LANGUAGE_CODE_MAP[code] ?? code;
}
